import { UserDb } from "../database/models/UserDb";

export class User {
    guid: string;
    email: string;

    createdDate: Date | null;
    lastModifiedDate: Date | null;
    deletedDate: Date | null;

    constructor(
        guid: string,
        email: string,
        createdDate: Date | null,
        lastModifiedDate: Date | null,
        deletedDate: Date | null,
    ) {
        this.guid = guid;
        this.email = email;

        this.createdDate = createdDate;
        this.lastModifiedDate = lastModifiedDate;
        this.deletedDate = deletedDate;
    }
}


export function UserToDbMapper(model: User) {
    const mapped: UserDb = {
        guid: model.guid,
        email: model.email,
        createdDate: model.createdDate,
        lastModifiedDate: model.lastModifiedDate,
        deletedDate: model.deletedDate,
    };
    return mapped;
}

export function UserFromDbMapper(db: UserDb) {
    const mapped: User = new User(
        db.guid,
        db.email,
        db.createdDate,
        db.lastModifiedDate,
        db.deletedDate,
    )
    return mapped;
}